@for (action of actionMenu; track $index; let isLast = $last) {
  <div class="menu-entry" (click)="onAction(action.name)">
    <button class="popover-button btn">
      <span class="label-text labelregularsmall pointer-event">{{action.label}}</span>
      @if(action.active) {
        <span class="spinner">
          <img loading="lazy" [src]="spinner.src" [alt]="spinner.alt" class="lesson-tile-study-icon"/>
        </span>
      }
    </button>
    @if (!isLast) { <hr class="divider"> }
  </div>
}
